<template>
    <div class="content-box">
        <Title/>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "list",
    data() {
        return {
            params: {
                json: 0,
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', '榜单 B2B')
        this.$store.dispatch('getText')
    }
}
</script>